import { render, staticRenderFns } from "./ExcelP17PrapaDebtReport.vue?vue&type=template&id=3b2a2450&"
import script from "./ExcelP17PrapaDebtReport.vue?vue&type=script&lang=js&"
export * from "./ExcelP17PrapaDebtReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports